import { render, staticRenderFns } from "./TrainingForm.vue?vue&type=template&id=4df678c6&"
import script from "./TrainingForm.vue?vue&type=script&lang=js&"
export * from "./TrainingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports